import { useEffect, useState } from 'react'
import { adapator_createDatabaseRef } from 'src/adapters'
import { DB_PATHS } from 'src/constants'
import firebaseInstance from 'src/adapters/common-set-up/firebase';

const useEsgSurveyQuestions = ({ orgId, periodId, isStandalone }) => {

    let currentVersionIdPath
    if (isStandalone) {
        currentVersionIdPath = ["esg-survey", orgId]
    } else {
        currentVersionIdPath = [
            ...DB_PATHS.assessmentSurvey
                .join("/")
                .replace("ORG_ID", orgId)
                .replace("PERIOD_ID", periodId)
                .split("/"),
        ]
    }

    const [currentSurveyVersionId, setCurrentSurveyVersionId] = useState(null)

    useEffect(() => {
        if (!orgId || orgId === "none") return
        const db = firebaseInstance.firestore()

        const versionRef = db.collection("esg-survey").doc(orgId)

        const unsubscribe = versionRef.onSnapshot((doc) => {
            const data = doc.data()
            setCurrentSurveyVersionId(data?.currentVersion)
        })

        return () => {
            if (unsubscribe) {
                unsubscribe()
            }
        }

    }, [orgId])


    const [refresh, setRefresh] = useState(0)

    const [currentSurvey, setCurrentSurvey] = useState(null)

    useEffect(() => {
        if (!orgId || orgId === "none") return
        if (!currentSurveyVersionId) return

        let unsubscribe
        const fetchSurveyQuestions = async () => {

            // console.count("fetchSurveyQuestions")
            // console.log("currentSurveyVersionId", currentSurveyVersionId)
            // console.log('orgId :>> ', orgId);

            try {


                const versionRef = adapator_createDatabaseRef(["global", "esg-survey", "questions", currentSurveyVersionId])

                unsubscribe = versionRef.onSnapshot((doc) => {
                    const data = doc.data()
                    if (data?.areas) {
                        setCurrentSurvey(data)
                    }
                })

            } catch (err) {
                console.log(err)
            }
        }
        fetchSurveyQuestions()

        return () => {
            if (unsubscribe) {
                unsubscribe()
            }
        }
    }, [orgId, refresh, currentSurveyVersionId])


    return { currentSurvey, setRefresh, currentVersionIdPath }
}

export default useEsgSurveyQuestions